/* Optional pendant + chain purchase. Prices and eligibility come from Shopify Liquid. */
(function () {
  function buildItems(cart, variantId, quantity, chainId, properties) {
    const count = (id) => cart.items.filter(i => Number(i.variant_id) === Number(id)).reduce((sum, i) => sum + i.quantity, 0);
    const items = [];
    const missing = Math.max(0, quantity - count(variantId));
    if (missing) items.push({id: Number(variantId), quantity: missing, ...(Object.keys(properties).length ? {properties} : {})});
    if (!count(chainId)) items.push({id: Number(chainId), quantity: 1, properties: {_Rivendell_offer: 'pendant-chain-v2'}});
    return items;
  }
  if (typeof module !== 'undefined') module.exports = {buildItems};
  if (typeof document === 'undefined') return;
  if (customElements.get('rivendell-chain-offer')) return;
  customElements.define('rivendell-chain-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('button');
      this.message = this.querySelector('[role=status]');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.button.disabled = false;
      this.button.addEventListener('click', () => this.add());
      // Variant changes can replace the hidden input without firing its own change event.
      this.closest('section')?.addEventListener('change', () => this.refresh());
      this.refresh();
    }
    selection() {
      const form = document.getElementById(this.dataset.form) || this.form;
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      const variant = this.variants.find(v => v.id === id);
      const properties = {};
      for (const [name, value] of data) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      return {id, quantity, variant, properties};
    }
    refresh() {
      if (this.busy) return;
      const s = this.selection();
      this.button.disabled = !s.variant?.available || !Number.isInteger(s.quantity) || s.quantity < 1;
      this.button.textContent = s.variant?.available ? 'Add pendant + chain' : 'Pendant unavailable';
    }
    async add() {
      if (this.busy) return;
      const s = this.selection();
      if (!s.variant?.available || !Number.isInteger(s.quantity) || s.quantity < 1) { this.refresh(); return; }
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = 'Adding…';
      this.message.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
        const cart = await response.json();
        const items = buildItems(cart, s.id, s.quantity, this.dataset.chain, s.properties);
        if (items.length) {
          const added = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items})});
          const result = await added.json();
          if (!added.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'These items could not be added. Please check your cart.');
        }
        window.location.assign(root + 'cart');
      } catch (error) {
        this.message.textContent = error.message || 'Please check your cart and try again.';
        this.busy = false;
        this.refresh();
      }
    }
  });
})();
